export const SAVE_STAMP = 'SAVE_STAMP';

export function saveStamp(stamp) {
    return {
        type: SAVE_STAMP,
        payload: stamp,
    };
};